import React from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { CONSTRUCTION_SITE_PHOTOS } from "../../data/constructionSitePhotos";

const CARDS: { to: string; title: string; blurb: string }[] = [
  { to: "pre-construction", title: "Pre-construction", blurb: "Buildability reviews, scope alignment, and procurement planning." },
  { to: "new-build", title: "New build construction", blurb: "Residential and commercial new build delivery with programme control." },
  { to: "commercial-fit-out", title: "Commercial fit-out", blurb: "Base build, interiors, and phased delivery for commercial clients." },
  { to: "structural-works", title: "Structural works", blurb: "Structural alterations, envelope, and engineer coordination." },
  { to: "interior-fit-out", title: "Interior fit-out", blurb: "Partitions, finishes, and second fix with quality benchmarks." },
  { to: "design-coordination", title: "Design coordination", blurb: "RFIs, site communication, and design intent through delivery." },
  { to: "site-management-handover", title: "Site management & handover", blurb: "Site leadership, inspections, snagging, and structured handover." },
];

function Services() {
  const scrollTop = () => { window.scrollTo({ top: 0 }); }

  return (
    <main className="bg-white">
      <Helmet>
        <title>Services | MA Renovations</title>
        <meta name="description" content="Construction services: pre-construction, new build, commercial fit-out, structural works, interior fit-out, design coordination, and site management. MA Renovations." />
      </Helmet>

      <div className="pt-36 sm:pt-40 pb-10 px-6 max-w-5xl mx-auto">
        <h1 className="font-display text-3xl sm:text-4xl text-navy font-bold tracking-tight">Services</h1>
        <p className="mt-2 text-slate-500">Principal contractor capabilities from pre-construction to handover.</p>
      </div>

      <section className="px-6 pb-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 max-w-5xl mx-auto gap-5">
          {CARDS.map(({ to, title, blurb }, i) => (
            <Link key={to} to={to} className="group block rounded overflow-hidden border border-slate-200 hover:border-accent transition-colors" onClick={scrollTop}>
              {CONSTRUCTION_SITE_PHOTOS[i] && (
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={CONSTRUCTION_SITE_PHOTOS[i]} alt={title} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" />
                </div>
              )}
              <div className="p-5">
                <h2 className="font-display font-semibold text-navy group-hover:text-accent transition-colors">{title}</h2>
                <p className="text-slate-500 text-sm mt-1">{blurb}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </main>
  )
}

export default Services;
